import DataCollection, {
  OverridablePropsWithValue,
} from '@storefront/services/DataCollection';
import { SimpleUiEvent as BaseSimpleUiEvent } from '@storefront/types/webanalytics';

export interface SimpleUiExtended extends BaseSimpleUiEvent {
  override?: OverridablePropsWithValue;
  additionalInformation?: {
    eventTracingId?: string;
    tenantId?: string;
    stratusUserId?: string;
    retryCount?: number;
  };
}

export type AdditionalInformation = {
  eventTracingId?: string;
  tenantId?: string;
  stratusUserId?: string;
  retryCount?: number;
};
export type SendAnalyticsProps = {
  simpleUiEvent: SimpleUiExtended;
  override?: OverridablePropsWithValue;
  additionalInformation?: AdditionalInformation;
};

export const sendAnalytics = async (props: SendAnalyticsProps) => {
  const {
    simpleUiEvent,
    override = {} as OverridablePropsWithValue,
    additionalInformation = {} as AdditionalInformation,
  } = props;

  const isEmptyOverride = Object.keys(override).length === 0;
  const isEmptyAdditionalInformation =
    Object.keys(additionalInformation).length === 0;

  if (isEmptyOverride) {
    if (isEmptyAdditionalInformation)
      await DataCollection.sendEvent(simpleUiEvent);
    else {
      const {
        eventTracingId = '',
        retryCount = 0,
        stratusUserId = '',
        tenantId = '',
      } = additionalInformation;
      await DataCollection.sendEvent(
        simpleUiEvent,
        null,
        eventTracingId,
        retryCount,
        tenantId,
        stratusUserId
      );
    }
  } else if (isEmptyAdditionalInformation) {
    await DataCollection.sendEvent(simpleUiEvent, override);
  } else {
    const {
      eventTracingId = '',
      retryCount = 0,
      stratusUserId = '',
      tenantId = '',
    } = additionalInformation;
    await DataCollection.sendEvent(
      simpleUiEvent,
      override,
      eventTracingId,
      retryCount,
      tenantId,
      stratusUserId
    );
  }
};
